export function isDrinkEvent(event) {
  return event?.type === "drink" || event?.type === "death";
}

export function recentDrinkEvents(events, now = Date.now(), maxAge = 5000) {
  if (!Array.isArray(events)) return [];
  return events.filter((event) => isDrinkEvent(event) && now - event.at < maxAge);
}

export function personalDrinkEvent(events, playerId) {
  if (!playerId) return null;
  return [...events].reverse().find((event) => event.playerId === playerId) || null;
}

// The phone's "Du blev träffad" line. Skål!, Shotroulette and Smällkaramellen can make
// you drink from your own card, and "Alice skickade effekten" read by Alice is nonsense.
export function drinkAlertSource(event, playerId) {
  // Fatigue is nobody's attack, and "Ta dina klunkar" with nobody named read as a glitch.
  if (event.cause === "fatigue") return "Din kortlek är tom — utmattningen växer med en klunk varje tur.";
  if (!event.sourceName) return "Ta dina klunkar.";
  return event.sourceId === playerId ? "Det var ditt eget kort." : `${event.sourceName} skickade effekten.`;
}

export function drinkEventText(event) {
  const suffix = `${event.amount} klunk${event.amount === 1 ? "" : "ar"}`;
  if (event.cause === "fatigue") {
    return event.type === "death" ? `är ute av utmattning — drick ${suffix} + en shot!` : `har slut på kort — drick ${suffix} i utmattning`;
  }
  // Dying means drinking what was left up to the cap, plus a shot — overkill is
  // clamped in addSips, so the event's amount is exactly that remainder.
  return event.type === "death"
    ? `är ute — drick ${suffix} + en shot!`
    : `måste dricka ${suffix}`;
}

// The title counts people, not events: one player can be hit twice in a volley, and
// "Alla träffade" over two names at a table of ten claimed hits nobody took.
export function boardDrinkSummary(events) {
  const safeEvents = Array.isArray(events) ? events : [];
  const people = new Set(safeEvents.map((event) => event.playerId ?? event.playerName)).size;
  return {
    title: people > 1 ? `${people} träffade` : safeEvents[0]?.playerName || "",
    events: safeEvents,
  };
}
